/**
 * SkillFilters - Kategori pill'leri + sort dropdown
 */
import { Search } from 'lucide-react'

export const CATEGORIES = ['All', 'Development', 'Data', 'Testing', 'DevOps', 'Productivity', 'Research', 'Communication']

export const SORT_OPTIONS = [
  { value: 'popular', label: 'Most Popular' },
  { value: 'new', label: 'Newest' },
  { value: 'rating', label: 'Top Rated' },
]

interface SkillFiltersProps {
  search: string
  onSearch: (v: string) => void
  activeCategory: string
  onCategory: (v: string) => void
  sort: string
  onSort: (v: string) => void
}

export default function SkillFilters({ search, onSearch, activeCategory, onCategory, sort, onSort }: SkillFiltersProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {/* Search + Sort */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1 }}>
          <Search size={15} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
          <input
            type="text"
            placeholder="Search skills..."
            value={search}
            onChange={e => onSearch(e.target.value)}
            style={{
              width: '100%', padding: '10px 14px 10px 36px',
              background: 'var(--card-bg)', border: '1px solid var(--border-color)',
              borderRadius: '8px', color: 'var(--text-primary)', fontSize: '13px',
              boxSizing: 'border-box'
            }}
          />
        </div>
        <select
          value={sort}
          onChange={e => onSort(e.target.value)}
          style={{
            padding: '10px 12px', background: 'var(--card-bg)',
            border: '1px solid var(--border-color)', borderRadius: '8px',
            color: 'var(--text-primary)', fontSize: '13px', cursor: 'pointer', flexShrink: 0
          }}
        >
          {SORT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>

      {/* Category pills */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            onClick={() => onCategory(cat)}
            style={{
              padding: '6px 14px', borderRadius: '20px', fontSize: '12px',
              fontWeight: 600, cursor: 'pointer',
              background: activeCategory === cat ? '#3b82f6' : 'var(--card-bg)',
              color: activeCategory === cat ? '#fff' : 'var(--text-secondary)',
              border: activeCategory === cat ? '1px solid #3b82f6' : '1px solid var(--border-color)'
            }}
          >
            {cat}
          </button>
        ))}
      </div>
    </div>
  )
}
